import React from 'react';
import { ContainerBGStyleListTypes, TextComponentLayout } from '../../utils/utils';
import TextComponent from '../TextComponent/textComponent';
import GetInvolvedForm from './GetInvolvedForm/getInvolvedForm';
import './getInvolvedContainer.scss';

const GetInvolvedContainer = () => {
  return (
    <div className={`container-bg ${ContainerBGStyleListTypes.LIGHTPAW} get-involved-container`}>
      <div className="container partner-content-wrapper">
        <div className="text-wrapper">
          <TextComponent
            layoutStyle={TextComponentLayout.LEFT}
            heading="Get Involved"
            description="The TurfMutt Foundation encourages outdoor learning experiences, stewardship of our green spaces and care for living landscapes for the benefit of all by teaching about the outdoors and educating citizens about sustainability."
          />
  <p style={{fontSize:"18px"}}>Chuck Bowen, Director, Communications and Member Relations, <br /><a href="tel:7036782988">703-678-2988</a>, <a href="mailto:cbowen@opei.org">cbowen@opei.org</a></p>
  <p style={{fontSize:"18px"}}>Debbi Mayster, Four Leaf Public Relations, <br /><a href="tel:2409886243">240-988-6243</a>, <a href="mailto:Debbi@fourleafpr.com">Debbi@fourleafpr.com</a></p>
        </div>
        <div className="form-wrapper">
          <GetInvolvedForm />
        </div>
      </div>
    </div>
  );
};

export default GetInvolvedContainer;
